var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.469 40.0463L38.8178 32.3951C38.2504 31.8278 37.3307 31.8278 36.7633 32.3951L33.3457 28.9776C35.6402 25.9055 36.7873 22.2431 36.7873 18.5807C36.7873 14.1263 35.0881 9.67192 31.7042 6.28315C24.6354 -0.780566 12.9525 -0.482369 6.27876 7.17774C0.613653 13.6802 0.631483 23.543 6.3171 30.0275C9.78575 33.9836 14.5989 35.9615 19.4065 35.9615C23.069 35.9615 26.7313 34.8144 29.8033 32.52L33.2209 35.9376C32.6536 36.5049 32.6536 37.4247 33.2209 37.992L40.7757 45.5467C41.4879 46.2589 42.4243 46.7355 43.4298 46.7932C44.5785 46.8591 45.6649 46.4421 46.469 45.6431C48.0098 44.0976 48.0098 41.5872 46.469 40.0463ZM29.1794 28.3536C23.7937 33.7392 15.0242 33.744 9.63373 28.3536C4.24335 22.9679 4.24335 14.1983 9.63373 8.80795C12.3265 6.11035 15.869 4.76633 19.4065 4.76633C22.949 4.76633 26.4865 6.11035 29.1794 8.80795C34.5698 14.1983 34.5698 22.9679 29.1794 28.3536Z",
    fill: "#3A57FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0831 14.2939H27.7498C28.1346 14.2939 28.4466 14.6059 28.4466 14.9907V25.7013C28.4466 26.0862 28.1346 26.3981 27.7498 26.3981H25.0831C24.6983 26.3981 24.3864 26.0862 24.3864 25.7013V14.9907C24.3864 14.6059 24.6983 14.2939 25.0831 14.2939Z",
    fill: "#494949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0632 19.5443H13.73C14.1148 19.5443 14.4267 19.8563 14.4267 20.2411V25.7013C14.4267 26.0861 14.1148 26.3981 13.73 26.3981H11.0632C10.6784 26.3981 10.3665 26.0861 10.3665 25.7013V20.2411C10.3665 19.8563 10.6784 19.5443 11.0632 19.5443Z",
    fill: "#494949"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0756 10.7628H20.7375C21.1223 10.7628 21.4343 11.0748 21.4343 11.4596V25.7013C21.4343 26.0862 21.1223 26.3981 20.7375 26.3981H18.0756C17.6907 26.3981 17.3788 26.0862 17.3788 25.7013V11.4596C17.3788 11.0748 17.6907 10.7628 18.0756 10.7628Z",
    fill: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis);
export default __webpack_public_path__ + "static/media/analysis.e7d81db69dc8b1ce502eec342824f9ec.svg";
export { ForwardRef as ReactComponent };